import {request} from '../utils/request';
import {formApi} from '../config/urlConfig';

/**
 * 通过表单id查找表单信息
 * @param data
 */
export const getFormById = (data) =>{
  let id = data.id;
  if (id && id.includes('__')) {
    id = id.split('__')[1];
  }
  return request({
    url: `${formApi}/form_design/get/${data.domainCode}/${id}`,
    method: 'get'
  });
}


/**
 * 根据表单id list 批量查询表单
 * @param data
 */
export const queryDesignByIdList = (data: any) =>
  request({
    url: `${formApi}/form_design/queryDesignByIdList`,
    method: 'post',
    data,
  });

/**
 * 分页查询
 * @param data
 */
export const pageQuery = (data: any) =>
  request({
    url: `${formApi}/form_design/pageQuery`,
    method: 'post',
    data,
  });

/**
 * 根据ID查询表单（当前领域找不到，找标准库里面的）
 * @param data
 */
export const getDomainOrStandardFormById = (data: any) =>
  request({
    url: `${formApi}/form_design/getDomainOrStandardFormById`,
    method: 'post',
    data,
  });

/**
 * 根据条件查询所有表单信息
 */
export const listAllForms = (data: any) =>
  request({
    url: `${formApi}/form_design/listAllForms`,
    method: 'post',
    data,
  });

/**
 * 根据表单名称查询表单数量
 */
export const countByParam = (data: any) =>
  request({
    url: `${formApi}/form_design/countByParam`,
    method: 'post',
    data,
  });

/**
 * 拷贝表单及其所绑定的函数到指定的领域下
 * @param data
 */
export const copyFormAndBindFun = (data: any) =>
  request({
    url: `${formApi}/form_design/copyFormAndBindFun`,
    method: 'post',
    data,
  });

/**
 * 根据条件查询所有表单信息+标准表单
 */
export const listAllFormsIncludeStandard = (data: any) =>
  request({
    url: `${formApi}/form_design/listAllFormsIncludeStandard`,
    method: 'post',
    data,
  });
